/* Sunkissed custom (Oct 7 2026): sand-free towel add-on in the cart drawer.
   Shows once, under the cart items, when the bag has swimwear but no towel.
   Shopper picks one of a few towels (in-stock only, prices read live from /products/<handle>.js)
   and adds it with one tap. Hidden when a towel is already in the bag or none are in stock.
   Oct 12 2026: towel prices show in the shopper's own currency (window.SK_INTL, snippets/sk-intl.liquid). */
(function () {
  'use strict';
  var HANDLES = ['milos-sand-free-beach-towel', 'stonewashed-bali-towel', 'bondi-sand-free-beach-towel-2', 'stonewashed-tuscany-towel', 'positano'];
  var MAX_SHOWN = 3;
  var FREE_SHIP_CENTS = 10000; // $100 (USD), US and Canada; used only if sk-intl.liquid is missing
  var BOX_CLASS = 'sk-towel-offer';
  var products = null, chosen = 0, busy = false, loading = null;

  function short(c) { return window.SK_INTL ? SK_INTL.money(c) : ('$' + (c / 100).toFixed(2)).replace('.00', ''); }
  function freeShipCents() { return window.SK_INTL ? SK_INTL.freeShipCents() : FREE_SHIP_CENTS; }
  function fetchJson(u) { return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function isTowel(it) { return /towel/i.test(it.product_title || '') || /towel/i.test(it.product_type || ''); }
  function isSwim(it) { return /\b(top|bottom|one piece|bon bon|sirena|set)\b/i.test(it.product_title || ''); }
  function imgOf(p) { var s = p.featured_image || (p.images && p.images[0]) || ''; if (s && s.indexOf('//') === 0) s = 'https:' + s; return s ? s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; }
  function nameOf(p) { return (p.title || '').split(' • ')[0].split(' - ')[0]; }

  function load() {
    if (products) return Promise.resolve(products);
    if (loading) return loading;
    loading = Promise.all(HANDLES.map(function (h) { return fetchJson('/products/' + h + '.js'); })).then(function (list) {
      products = list.filter(function (p) { return p && p.available && p.variants && p.variants.some(function (v) { return v.available; }); }).slice(0, MAX_SHOWN);
      return products;
    });
    return loading;
  }

  function remove() { var el = document.querySelector('.' + BOX_CLASS); if (el) el.parentNode.removeChild(el); }

  function render(cart) {
    var holder = document.querySelector('cart-items[data-items-holder], [data-items-holder]');
    if (!holder || !products || !products.length) { remove(); return; }
    var p = products[chosen] || products[0];
    var v = p.variants.filter(function (x) { return x.available; })[0];
    var freeAt = freeShipCents();
    var unlocks = cart.total_price < freeAt && cart.total_price + v.price >= freeAt;
    var el = document.querySelector('.' + BOX_CLASS);
    if (!el || el.parentNode !== holder) { remove(); el = document.createElement('div'); el.className = BOX_CLASS; el.style.cssText = 'display:block;width:100%;box-sizing:border-box'; holder.appendChild(el); }
    // Oct 7 2026 design C: one quiet row under the set card (photo, name and price, colour dots, Add)
    el.innerHTML =
      '<div class="sk-trow">' +
        (imgOf(p) ? '<img class="sk-trow__img" src="' + imgOf(p) + '" alt="">' : '') +
        '<div class="sk-trow__x"><b>Add a sand-free towel</b>' +
          '<div class="sk-trow__m">' + nameOf(p) + ' · ' + short(v.price) + (unlocks ? ' · ships free' : '') + '</div>' +
          '<div class="sk-trow__dots">' +
            products.map(function (q, i) {
              return '<button type="button" data-towel="' + i + '" aria-label="' + nameOf(q) + '" aria-pressed="' + (i === chosen ? 'true' : 'false') + '"' + (imgOf(q) ? ' style="background-image:url(' + imgOf(q) + ')"' : '') + '></button>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<button type="button" class="sk-trow__add" data-towel-add>Add</button>' +
      '</div>';
    Array.prototype.forEach.call(el.querySelectorAll('[data-towel]'), function (b) {
      b.addEventListener('click', function () { chosen = parseInt(this.getAttribute('data-towel'), 10); render(cart); });
    });
    el.querySelector('[data-towel-add]').addEventListener('click', function () {
      if (busy) return; busy = true;
      var btn = this; btn.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          busy = false;
          if (res.ok) { remove(); document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); }
          else { btn.textContent = (res.json && res.json.description) || 'Sold out'; }
        })
        .catch(function () { busy = false; btn.textContent = 'Try again'; });
    });
  }

  // Grammar fix for the bag header: "1 pieces" -> "1 piece"
  function fixPieces() {
    Array.prototype.forEach.call(document.querySelectorAll('.sk-bag-pieces'), function (el) {
      var c = el.querySelector('[data-cart-count]'); if (!c) return;
      var n = parseInt(c.textContent, 10); var word = n === 1 ? ' piece' : ' pieces';
      var last = el.lastChild;
      if (last && last.nodeType === 3 && last.textContent.trim() !== word.trim()) last.textContent = word;
    });
  }

  function update() {
    fixPieces();
    if (!document.querySelector('.cart__item[data-item]')) { remove(); return; }
    fetchJson('/cart.js').then(function (cart) {
      if (!cart || !cart.items.length) { remove(); return; }
      if (cart.items.some(isTowel) || !cart.items.some(isSwim)) { remove(); return; }
      load().then(function () { render(cart); });
    });
  }

  ['theme:cart:refresh', 'theme:cart:change', 'theme:cart:update', 'theme:cart-drawer:open', 'theme:product:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(update, 400); setTimeout(update, 1400); });
  });
  var mo = new MutationObserver(function (muts) {
    var external = muts.some(function (m) { var t = m.target; return !(t.closest && (t.closest('.' + BOX_CLASS) || t.closest('.set-offer-inline'))); });
    if (!external) return;
    clearTimeout(mo.__t); mo.__t = setTimeout(update, 300);
  });
  function watch() { var d = document.querySelector('cart-drawer, [data-cart-drawer], .drawer--cart'); if (d) mo.observe(d, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') { watch(); update(); } else document.addEventListener('DOMContentLoaded', function () { watch(); update(); });
})();
